import React from "react";

interface FooterProps {
  privacyPolicyUrl?: string;
  termsUrl?: string;
}

export function Footer({ privacyPolicyUrl, termsUrl }: FooterProps) {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-zinc-950 border-t border-[#a79c68]/15 pt-10 pb-8">
      <div className="max-w-5xl mx-auto px-6 sm:px-8 flex flex-col items-center gap-3">
        <p className="text-sm font-medium text-white/80 tracking-wide">
          Bossenberg Gear Up Adventures
        </p>
        <p className="text-sm text-gray-500 text-center">
          &copy; {currentYear} Way Up Creative. All rights reserved.
        </p>

        {(privacyPolicyUrl || termsUrl) && (
          <div className="flex gap-6 mt-1">
            {privacyPolicyUrl && (
              <a
                href={privacyPolicyUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs text-gray-600 hover:text-[#a79c68] transition-colors"
              >
                Privacy Policy
              </a>
            )}
            {termsUrl && (
              <a
                href={termsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs text-gray-600 hover:text-[#a79c68] transition-colors"
              >
                Terms & Conditions
              </a>
            )}
          </div>
        )}
      </div>
    </footer>
  );
}
